// extracted by mini-css-extract-plugin
module.exports = {"goals":"Goals_goals__2HsI-","title":"Goals_title__3Zrac","description":"Goals_description__1DTht"};